<template>
  <v-card outlined class="mr-3 ml-2">
    <v-card-text class="mt-3">
          <v-col class="clearColumnPadding mb-2">
            <h4 class="font-weight-light">{{labels.options}}</h4>
          </v-col>
          <v-col class="clearColumnPadding mb-2">
            <div id="options">
                <v-switch
                v-model="fullMap"
                :label="`${getTranslation('Map size')}: ${fullMap ? getTranslation('Full') : getTranslation('Croped')}`"
                dense
                hide-details="auto"
              ></v-switch>
              <v-switch
                v-if="mapType && mapType == 1"
                v-model="showArrow"
                :label="`${getTranslation('Direction')}: ${showArrow ? getTranslation('Turned on') : getTranslation('Turned off')}`"
                dense
                hide-details="auto"
                @change="showHideArrows"
              ></v-switch>
            </div>
          </v-col>
          <v-col class="clearColumnPadding mb-4">
            <VSelectAll
              :items="poiDropdownAdapted"
              :label="labels.selectPois"
              v-model="selectedPois"
            ></VSelectAll>
          </v-col>

          <v-row>
            <v-col sm="12" lg="6">
              <v-checkbox v-model="privateDrive" :label="labels.privateDrive" :disabled="disablePrivateBusinessCheckboxes" color="red"></v-checkbox>
            </v-col>

            <v-col sm="12" lg="6">
              <v-checkbox v-model="businessDrive" :label="labels.businessDrive" :disabled="disablePrivateBusinessCheckboxes" color="indigo"></v-checkbox>
            </v-col>
          </v-row>
          
          <FilterBuilder
            :incommingObject = incommingObject
            :formElements = elements
            :endPoint = "'reports/TravelHistory'"
            :blockedIntervals ="blockedIntervals"
            @dataProvided = handleProvidedFormBuilderData
            @apiResponded = findRoute
            @errorOccured = additionalErrorHandling
          />
    </v-card-text>
  </v-card>
</template>
<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import { getPois } from '../../../api/poi.api'
import store from '@/store/store'
import { mapState } from 'vuex'
import FilterBuilder from '@/components/v2/FilterBuilder'
import VSelectAll from '../../custom/VSelectAll'

export default {
  components: {
    TimeFilterV2: () => import('../TimeFilterV2'),
    FilterBuilder,
    VSelectAll
  },
  props: [ 'mapType' ],
  data() {
    return {
      incommingObject: {
        StoppedForMinutes: 4
      },
      searchByVehicles: true,
      label: translate('Select driver', 'reports.filter'),
      fullMap: true,
      showArrow: false,
      poiDropdown: [],
      selectedPois: [],
      blockedIntervals: [],
      labels: {
        btnTracking: translate('Show tracking history', 'mapFilters'),
        selectPois: translate('Choose Pois *', 'mapFilters'),
        options: translate('Options', 'mapFilters'),
        noData: translate('No data available', 'mapFilters'),
        privateDrive: translate('Private', 'mapFilters'),
        businessDrive: translate('Business', 'mapFilters')
      },
      privateDrive: false,
      businessDrive: false,
      disablePrivateBusinessCheckboxes: true,
      elements: [
        {
          key: 'searchByDrivers',
          component: 'v-switch',
          label: '$searchByDrivers',
          cols: 12,
          affects: [
            {
              key: 'Groups',
              change: {
                type: 'hide',
                whenNot: false
              }
            },
            {
              key: 'VehicleIds',
              change: {
                type: 'hide',
                whenNot: false
              }
            },
            {
              key: 'DriverIds',
              change: {
                type: 'hide',
                whenNot: true
              }
            },
            {
              key: 'RouteOptimization',
              change: {
                type: 'hide',
                whenNot: true
              }
            },
          ]
        },
        {
          key: 'Groups',
          affects: [
            {
              key: 'VehicleIds',
              change: {
                type: 'dataSource',
                api: {
                  endpoint: '/vehicles?withModem=true&GroupIds=',
                  associateValue: true
                }
              }
            }
          ],
          cols: 12,
          component: 'VSelectAll',
          dataSource: { endpoint: '/lookup/vehiclegroups' },
          label: '$groups',
          props: {
            multiple: true
          }
        },
        {
          key: 'VehicleIds',
          cols: 12,
          component: 'VSelectAll',
          dataSource: { endpoint: '/vehicles?withModem=true' },
          label: '$vehicle',
          props: {
            multiple: true,
            onlyDeselect: true
          },
          rules:"required"
        },
        {
          key: 'DriverIds',
          cols: 12,
          component: 'VSelectAll',
          dataSource: { endpoint: '/drivers' },
          props: {
            multiple: true,
            onlyDeselect: true
          },
          label: '$driver',
          hidden: true,
          rules:"required",
          affects: [
            {
              key: 'RouteOptimization',
              change: {
                type: 'disable',
                when: '',
              }
            },
            {
              key: 'RouteOptimization',
              change: {
                type: 'dataSource',
                api: {
                  endpoint: '/routeOptimization?DriverIds=',
                  associateValue: true
                }
              }
            }
          ]
        },
        {
          key: 'RouteOptimization',
          useCaseName: 'SearchRouteOptimizations',
          cols: 12,
          component: 'v-autocomplete',
          dataSource: { 
            endpoint: '/routeOptimization',
          },
          props: {
            multiple: false,
            onlyDeselect: true
          },
          label: '$optimizedRoutes',
          hidden: true,
          disabled: true
        },
        {
          key: 'StoppedForMinutes',
          cols: 12,
          rules: 'numeric',
          dataSource: { endpoint: '/drivers' },
          label: '$stoppedForMinutes'
        }
      ]
    }
  },
  computed: {
    ...mapState('history', ['isDrawing', 'fullHeightMap', 'searchObject']),
    poiDropdownAdapted() {
      let data = []
      this.poiDropdown.forEach(x => {
        data.push({
          text: x.name,
          value: x.id
        })
      })
      return data
    },
    mobileBereakPoint() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  beforeDestroy() {
    store.dispatch('history/saveRoutes', {
      routes: null,
      legendSource: null
    })
    store.dispatch('history/changeTableData', null)
    store.dispatch('history/changeMapHeight', true)
  },
  methods: {
    handleProvidedFormBuilderData(data) {
      store.dispatch('history/setSearchObject', data)
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'fields')
    },
    showHideArrows() {
      store.dispatch('history/displayDirections', this.showArrow)
    },
    findRoute(response) {
      store.dispatch('history/setDisplayTable', response.displayTable)
      store.dispatch('history/isDrawing', true)
      store.dispatch('history/changeMapHeight', !response.displayTable)
      this.disablePrivateBusinessCheckboxes = false
      if (this.searchObject.vehicleIds) {
        response.searchByVehicles = true
      } else {
        response.searchByVehicles = false
      }
      response.searchByVehicles = true
      if (response.details.length == 0) {
        store.dispatch('history/isDrawing', false)
        return store.dispatch(
          'notification/add',
          {
            type: 'warning',
            message: this.labels.noData
          },
          {
            root: true
          }
        )
      }

      let legendSource = this.searchObject.VehicleIds ? 'vehicle' : 'driver'
      store.dispatch('history/saveRoutes', {
        routes: response.details,
        legendSource: legendSource,
        routeOptimizationData: JSON.parse(response.routeOptimizationData)
      })
      store.dispatch('history/changeTableData', response)

      let privateDriveRoutes = []
      let businessDriveRoutes = []
      response.details.forEach((route, index) => {
        if(route.ioEventName == 'Privatna') {
          if(index == 0 || privateDriveRoutes.length == 0) {
            privateDriveRoutes[0] = [];
            privateDriveRoutes[0].push(route)
          } else if (route.ioEventName == response.details[index - 1].ioEventName) {
            privateDriveRoutes[privateDriveRoutes.length - 1].push(route)
          } else {
            let length = privateDriveRoutes.length
            privateDriveRoutes[length] = []
            privateDriveRoutes[length].push(route)
          }
        }

        if(route.ioEventName == 'Službena') {
          if(index == 0 || businessDriveRoutes.length == 0) {
            businessDriveRoutes[0] = [];
            businessDriveRoutes[0].push(route)
          } else if (route.ioEventName == response.details[index - 1].ioEventName) {
            businessDriveRoutes[businessDriveRoutes.length - 1].push(route)
          } else {
            let length = businessDriveRoutes.length;
            businessDriveRoutes[length] = []
            businessDriveRoutes[length].push(route)
          }
        }
      })

      store.dispatch('history/setPrivateDriveRoutes', privateDriveRoutes)
      store.dispatch('history/setBusinessDriveRoutes', businessDriveRoutes)
    },
    additionalErrorHandling() {
      store.dispatch('history/isDrawing', false)
    }
  },
  async mounted() {
    getPois().then(result => {
      this.poiDropdown = result.data
    })

    if (this.mobileBereakPoint) {
      this.fullMap = false
    }
  },
  watch: {
    fullMap: {
      handler() {
        store.dispatch('history/changeMapHeight', this.fullMap)
      }
    },
    fullHeightMap: {
      handler() {
        this.fullMap = this.fullHeightMap
      }
    },
    selectedPois: {
      handler() {
        let pois = []
        this.selectedPois.forEach(id => {
          let selectedPoiInfo = this.poiDropdown.find(x => x.id == id)
          if (selectedPoiInfo) {
            pois.push(selectedPoiInfo)
          }
        })
        store.dispatch('map/clearPois')
        pois.forEach(poi => store.dispatch('map/addPoi', poi))
      }
    },
    privateDrive: {
      handler() {
        this.$set(this.searchObject, 'privateDrive', this.privateDrive)
        this.$set(this.searchObject, 'businessDrive', this.businessDrive)
        store.dispatch('history/setSearchObject', this.searchObject)
      }
    },
    businessDrive: {
      handler() {
        this.$set(this.searchObject, 'privateDrive', this.privateDrive)
        this.$set(this.searchObject, 'businessDrive', this.businessDrive)
        store.dispatch('history/setSearchObject', this.searchObject)
      }
    }
  }
}
</script>
<style scoped>
.clearColumnPadding {
  padding: 0px;
}
.errorClass {
  color: #ff5252 !important ;
  caret-color: #ff5252 !important;
  font-size: 12px;
  text-align: left;
  line-height: 12px;
  padding-left: 4px;
}
</style>
